/** Copy of the vendorOrders page (Operations), ported from VentaHub. */
export const vendorOrders = {
  shift: {
    open: 'Shift',
    title: 'Shift {{code}}',
    hint: 'Move the order to another warehouse or vendor. It is reopened there with the same code and lines; its PO link and approval stay behind. Not possible once a vendor invoice is mapped.',
    warehouse: 'Warehouse',
    vendor: 'Vendor',
    chooseVendor: 'Choose a vendor',
    button: 'Shift order',
    done: 'Vendor order {{code}} shifted.',
  },
  merge: {
    open: 'Merge',
    title: 'Merge orders into {{code}}',
    hint: 'Their lines are added to this order and they are deleted. Each must be in this warehouse, for this vendor and currency, with no vendor invoice and no PO of its own.',
    codes: 'Vendor order codes (one per line)',
    button: 'Merge orders',
    done_one: '{{count}} order merged.',
    done_other: '{{count}} orders merged.',
  },
  title: 'Vendor orders',
  description: 'What we have ordered from vendors, to arrive at one of our warehouses.',
  newOrder: 'New vendor order',
  newOrderHint: 'Choose a warehouse and a vendor in the filters first.',
  empty: 'No vendor orders match',
  emptyHint: 'Widen the filters, or create a vendor order.',
  filters: {
    code: 'Order code',
    sku: 'SKU code',
    warehouse: 'Warehouse',
    vendor: 'Vendor',
    created: 'Created',
    sort: 'Sort by',
    clear: 'Clear filters',
  },
  sorts: {
    newest: 'Newest first',
    oldest: 'Oldest first',
    dateNewest: 'Order date, newest',
    dateOldest: 'Order date, oldest',
    codeAsc: 'Code, A to Z',
    codeDesc: 'Code, Z to A',
    amountDesc: 'Amount, high to low',
    amountAsc: 'Amount, low to high',
  },
  columns: {
    code: 'Order code',
    vendor: 'Vendor',
    warehouse: 'Warehouse',
    date: 'Order date',
    po: 'Purchase order',
    units: 'Units',
    amount: 'Amount',
    lines: 'Lines',
    status: 'Status',
    created: 'Created',
    actions: 'Actions',
  },
  status: { approved: 'Approved', pending: 'Not reviewed' },
  open: 'Open vendor order {{code}}',
  delete: 'Delete vendor order {{code}}',
  detail: {
    vendor: 'Vendor',
    warehouse: 'Warehouse',
    date: 'Order date',
    validTill: 'Valid until',
    po: 'Purchase order',
    units: 'Units',
    amount: 'Amount',
    comment: 'Comment',
    lines: 'Lines',
    noLines: 'This vendor order has no lines.',
    editLines: 'Edit lines',
    editHeader: 'Edit details',
    uploadLines: 'Upload lines',
    export: 'Download lines',
    warnings: 'Worth a second look',
    recorded: 'Recorded cost',
  },
  lineColumns: {
    sku: 'SKU',
    name: 'Name',
    quantity: 'Quantity',
    cost: 'Cost',
    amount: 'Amount',
    recorded: 'Recorded cost',
  },
  form: {
    createTitle: 'New vendor order',
    createDescription:
      'Cost is entered per line; a difference from the vendor’s record is a warning.',
    linesTitle: 'Edit lines of {{code}}',
    linesDescription:
      'Replaces every line. Quantities cannot go below what vendor invoices carry or above what the purchase order allows.',
    warehouse: 'Warehouse',
    vendor: 'Vendor',
    choose: 'Choose…',
    code: 'Order code',
    currency: 'Currency',
    po: 'Purchase order code',
    choosePo: 'Choose a purchase order',
    poRequired: 'Choose the purchase order.',
    date: 'Order date',
    validTill: 'Valid until',
    comment: 'Comment',
    lines: 'Lines',
    lineSku: 'SKU code, line {{n}}',
    lineQuantity: 'Quantity, line {{n}}',
    lineCost: 'Cost, line {{n}}',
    headerSku: 'SKU code',
    headerQuantity: 'Quantity',
    headerCost: 'Cost',
    addLine: 'Add a line',
    removeLine: 'Remove line {{n}}',
    lineUpload: {
      template: 'Download template',
      upload: 'Upload lines from a file',
      download: 'Download these lines',
      empty: 'No SKU rows found in the file.',
      unreadable: 'Could not read the file.',
      loaded_one: 'Loaded {{count}} line from the file.',
      loaded_other: 'Loaded {{count}} lines from the file.',
    },
    check: 'Check',
    checking: 'Checking…',
    save: 'Save',
    create: 'Create',
    saving: 'Saving…',
    checkedOk: 'Looks good: {{units}} units across the lines.',
    warnings: 'Worth a second look',
    problems: 'Fix these first',
    downloadProblems: 'Download problems',
    row: 'Line {{n}}',
    codeRequired: 'Enter the order code.',
    skuRequired: 'Enter the SKU code.',
    quantityInvalid: 'Quantity must be a whole number of one or more.',
    costInvalid: 'Cost must be a number of zero or more.',
    currencyInvalid: 'Use a three-letter currency code.',
    chooseWarehouse: 'Choose a warehouse.',
    chooseVendor: 'Choose a vendor.',
    created: 'Vendor order {{code}} created.',
    linesSaved: 'Lines saved.',
    headerTitle: 'Edit {{code}}',
    headerDescription: 'Only what you change is saved. The warehouse cannot be changed here.',
    unlinkPo: 'Remove the purchase order link',
    headerSaved: 'Vendor order updated.',
  },
  remove: {
    title: 'Delete vendor order {{code}}?',
    description:
      'It will disappear from the list. This is refused while a vendor invoice is mapped to it.',
    cancel: 'Cancel',
    confirm: 'Delete',
    deleting: 'Deleting…',
    deleted: 'Vendor order {{code}} deleted.',
  },
  upload: {
    title: 'Upload lines for {{code}}',
    description:
      'SKU Code, Quantity and Cost. The sheet is every line of this order: lines it leaves out are removed. It goes for approval, and the lines change once it is accepted.',
  },
} as const
